import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  settings: [],
};

const getters = {
  getSettings: (state) => state.settings,
};

const actions = {
  async fetchSettings({ commit }) {
    try {
      const resp = await api.get("/settings");

      if (resp.status == 200) {
        const settings = resp.data.data.settings;
        console.log("rrr", settings);
        commit("setSettings", settings);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateSetting({ commit }, setting) {
    console.log("setting:", setting);
    try {
      const id = setting.id;
      setting._method = "patch";

      const resp = await api.post(`/settings/${id}`, setting);
      if (resp.status == 200) {
        const setting = resp.data.data;
        commit("updateSetting", setting);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setSettings(state, settings) {
    state.settings = settings;
  },
  updateSetting(state, setting) {
    const id = setting.id;
    const index = state.settings.findIndex((setting) => setting.id == id);
    if (index !== -1) {
      state.settings[index] = setting;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
